import React from 'react'
import Firstproduct3details from '../Advertisement/Firstproduct3details'

function Supersalearea1() {
    return (
        <div>
            <Firstproduct3details/>
        </div>
    )
}

export default Supersalearea1
